module.exports = __webpack_public_path__ + "img/img1.9e891ce8.png";